import { useState } from "react";
import { Modal, Button, Tooltip } from "antd";
import { EyeOutlined, DownloadOutlined, FileTextOutlined } from "@ant-design/icons";

const isPdf = (url, mimeType) => {
  if (mimeType) return mimeType === "application/pdf";
  return /\.pdf($|\?)/i.test(url || "");
};
const isImage = (url, mimeType) => {
  if (mimeType) return mimeType.startsWith("image/");
  return /\.(png|jpe?g|gif|webp)($|\?)/i.test(url || "");
};

/**
 * A claim document, shown as a card that opens an in-app preview modal
 * (PDF via iframe, image inline) instead of navigating away in a new tab —
 * same pattern as the EasyLife staff app's own document link component.
 */
const DocumentLink = ({ url, name, type, mimeType }) => {
  const [open, setOpen] = useState(false);

  if (!url) return null;

  const pdf = isPdf(url, mimeType);
  const image = isImage(url, mimeType);
  const previewable = pdf || image;

  return (
    <>
      <div
        role={previewable ? "button" : undefined}
        onClick={previewable ? () => setOpen(true) : undefined}
        style={{
          display: "flex", alignItems: "center", gap: 10, padding: "10px 14px",
          borderRadius: 10, border: "1px solid var(--border-color)", background: "var(--bg-hover)",
          cursor: previewable ? "pointer" : "default",
        }}
      >
        <FileTextOutlined style={{ color: "#189F6B", fontSize: 16 }} />
        <span style={{ flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: 13.5 }}>
          {name}
          {type && <span style={{ color: "var(--text-secondary)", marginLeft: 6, fontSize: 11.5 }}>({type})</span>}
        </span>
        {previewable && (
          <Tooltip title="Preview">
            <EyeOutlined style={{ color: "#189F6B" }} />
          </Tooltip>
        )}
        <Tooltip title="Download">
          <a href={url} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} style={{ color: "var(--text-secondary)" }}>
            <DownloadOutlined />
          </a>
        </Tooltip>
      </div>

      {previewable && (
        <Modal
          open={open}
          onCancel={() => setOpen(false)}
          footer={
            <a href={url} target="_blank" rel="noreferrer" download>
              <Button icon={<DownloadOutlined />}>Download</Button>
            </a>
          }
          width="80%"
          style={{ top: 20 }}
          title={name || "Document Preview"}
          destroyOnClose
        >
          {pdf ? (
            <iframe src={url} title={name || "PDF Preview"} style={{ width: "100%", height: "75vh", border: "none", borderRadius: 4 }} />
          ) : (
            <img src={url} alt={name} style={{ maxWidth: "100%", maxHeight: "75vh", display: "block", margin: "0 auto" }} />
          )}
        </Modal>
      )}
    </>
  );
};

export default DocumentLink;
